export const GET_SPECIFICATION = "GET_SPECIFICATION"
export const GET_SPECIFICATION_BY_ID = "GET_SPECIFICATION_BY_ID"
export const GET_SPECIFICATION_BY_ID_SUCCESS = "GET_SPECIFICATION_BY_ID_SUCCESS"
export const GET_SPECIFICATION_SUCCESS = "GET_SPECIFICATION_SUCCESS"
export const GET_SPECIFICATION_ERROR = "GET_SPECIFICATION_ERROR"

export const GET_SPECIFICATION_LIST = "GET_SPECIFICATION_LIST"
export const GET_SPECIFICATION_LIST_SUCCESS = "GET_SPECIFICATION_LIST_SUCCESS"
export const GET_SPECIFICATION_LIST_ERROR = "GET_SPECIFICATION_LIST_ERROR"
